export enum ReferenceCondition {
  'ISO' = 'ISO',
  'FR_METERING' = 'FR_METERING',
  'FR_MARKET' = 'FR_MARKET',
  'BE_METERING' = 'BE_METERING',
  'IT_METERING' = 'IT_METERING',
  'IT_MARKET' = 'IT_MARKET',
  'NL_METERING' = 'NL_METERING',
  'DE_METERING' = 'DE_METERING',
  'ES_METERING' = 'ES_METERING',
  'TR_METERING' = 'TR_METERING',
  'GB_METERING' = 'GB_METERING',
  'CZ_METERING' = 'CZ_METERING',
}
